import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { meishoKbn } from "services/codes";
import { PageableResponse } from "../PageableResponse";

export type B000111FindRequest = { meishoKbn: string } & Partial<{
  meishoCdFrom: string;
  meishoCdTo: string;
  name: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000111FindResponse = {
  meishoKbn: string;
  meishoCd: string;
  meishoNm1: string;
  meishoKana1: string;
  meishoNm2: string;
  meishoKana2: string;
  sujikomoku1: number;
  sujikomoku2: number;
  kbn1: string;
  sakujoyoteiKbn: number;
};

export const B000111Find = (props: B000111FindRequest) => {
  return RestClient.get<PageableResponse<B000111FindResponse[]>>(
    "b000111/find",
    {
      params: props,
    }
  );
};

// 名称検索(添付伝票)リクエスト
export type B000111FindTenpudenpyoCdRequest = {
  denpyoshubetsuCd: string;
  meishoKbn: string;
} & Partial<{
  meishoCdFrom: string;
  meishoCdTo: string;
  name: string;
  page: number;
  sort: string[];
  size: number;
}>;

// 名称検索(添付伝票)
export const B000111FindTenpudenpyoCd = (
  props: B000111FindTenpudenpyoCdRequest
) => {
  return RestClient.get<PageableResponse<B000111FindResponse[]>>(
    "b000111/findTenpudenpyoCd",
    {
      params: props,
    }
  );
};

export type B000111GetRequest = {
  meishoKbn: string;
  meishoCd: string;
};

export const B000111Get = (props: B000111GetRequest) => {
  return RestClient.get("b000111/get", {
    params: props,
  });
};

// 名称取得(添付伝票)
export type B000111GetTenpudenpyoCdRequest = {
  denpyoshubetsuCd: string;
  meishoKbn: string;
  meishoCd: string;
};

export const B000111GetTenpudenpyoCd = (
  props: B000111GetTenpudenpyoCdRequest
) => {
  return RestClient.get("b000111/getTenpudenpyoCd", {
    params: props,
  });
};

//得意先分類名表示
export const B000111TokuibunNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tokuibunCd === "" || data.torihikisakibun === "") {
    methods.setValue("tokuibunNm", "");
    return;
  }
  await B000111Get({
    meishoCd: data.tokuibunCd,
    meishoKbn: data.torihikisakibun,
  })
    .then((response) => {
      methods.setValue("tokuibunNm", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuibunNm", "");
    });
};

//発送先名表示
export const B000111HasosakiNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.hasosakiCd === "") {
    methods.setValue("hasosakiNm", data.hasosakiCd);
    return;
  }
  await B000111Get({ meishoCd: data.hasosakiCd, meishoKbn: "35" })
    .then((response) => {
      methods.setValue("hasosakiNm", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("hasosakiNm", "");
    });
};

//発送区分名表示
export const B000111HasokbnNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.hasokbnCd === "") {
    methods.setValue("hasokbnNm", data.hasokbnCd);
    return;
  }
  await B000111Get({ meishoCd: data.hasokbnCd, meishoKbn: "36" })
    .then((response) => {
      methods.setValue("hasokbnNm", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("hasokbnNm", "");
    });
};

//伝票種別名表示
export const B000111DenpyoshubetsuNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.denpyoshubetsuCd === "") {
    methods.setValue("denpyoshubetsuNm", data.denpyoshubetsuCd);
    return;
  }
  await B000111Get({
    meishoCd: data.denpyoshubetsuCd,
    meishoKbn: "33",
  })
    .then((response) => {
      methods.setValue("denpyoshubetsuNm", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("denpyoshubetsuNm", "");
    });
};

//伝票種別名表示(添付伝票クリア処理も行う)
//受注入力、受注ワーク入力、売上入力
export const B000111DenpyoshubetsuNmAndTenpudenpyo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.denpyoshubetsuCd === "") {
    methods.setValue("denpyoshubetsuNm", data.denpyoshubetsuCd);
    methods.setValue("tenpudenpyoCd", data.denpyoshubetsuCd);
    methods.setValue("tenpudenpyoNm", data.denpyoshubetsuCd);
    return;
  }
  await B000111Get({
    meishoCd: data.denpyoshubetsuCd,
    meishoKbn: "33",
  })
    .then((response) => {
      methods.setValue("denpyoshubetsuNm", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("denpyoshubetsuNm", "");
      methods.setValue("tenpudenpyoCd", "");
      methods.setValue("tenpudenpyoNm", "");
    });
};

//運送会社名表示
export const B000111UnsogaishaNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.unsogaishaCd === "") {
    methods.setValue("unsogaishaNm", data.unsogaishaCd);
    return;
  }
  await B000111Get({
    meishoCd: data.unsogaishaCd,
    meishoKbn: "32",
  })
    .then((response) => {
      methods.setValue("unsogaishaNm", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("unsogaishaNm", "");
    });
};

//ライン名表示
export const B000111LineNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.lineCd === "") {
    methods.setValue("lineNm", data.lineCd);
    return;
  }
  await B000111Get({ meishoCd: data.lineCd, meishoKbn: "31" })
    .then((response) => {
      methods.setValue("lineNm", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("lineNm", "");
    });
};

//備考表示
export const B000111Biko = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();

  if (typeof data.bikoCdBefore !== "undefined") {
    if (data.bikoCdBefore === data.bikoCd) {
      return;
    } else {
      methods.setValue("bikoCdBefore", data.bikoCd);
    }
  }

  if (data.bikoCd === "") {
    methods.setValue("biko", data.bikoCd);
    return;
  }
  await B000111Get({ meishoCd: data.bikoCd, meishoKbn: "2" })
    .then((response) => {
      methods.setValue("biko", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("biko", "");
    });
};

//添付伝票名表示
export const B000111TenpudenpyoNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tenpudenpyoCd === "") {
    methods.setValue("tenpudenpyoNm", data.tenpudenpyoCd);
    return;
  }
  await B000111Get({ meishoCd: data.tenpudenpyoCd, meishoKbn: "34" })
    .then((response) => {
      methods.setValue("tenpudenpyoNm", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tenpudenpyoNm", "");
    });
};

//伝票種別を検索条件に含めて添付伝票名表示
//受注入力、受注ワーク入力、売上入力
export const B000111TenpudenpyoNmByDenpyoshubetsu = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tenpudenpyoCd === "") {
    methods.setValue("tenpudenpyoNm", data.tenpudenpyoCd);
    return;
  }
  await B000111GetTenpudenpyoCd({
    denpyoshubetsuCd: data.denpyoshubetsuCd,
    meishoCd: data.tenpudenpyoCd,
    meishoKbn: "34",
  })
    .then((response) => {
      methods.setValue("tenpudenpyoNm", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tenpudenpyoNm", "");
    });
};

//加工種別名(From)表示
export const B000111KakoshubetsuNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.kakoshubetsuCdFrom === "") {
    methods.setValue("kakoshubetsuNmFrom", data.kakoshubetsuCdFrom);
    return;
  }
  await B000111Get({ meishoCd: data.kakoshubetsuCdFrom, meishoKbn: "38" })
    .then((response) => {
      methods.setValue("kakoshubetsuNmFrom", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("kakoshubetsuNmFrom", "");
    });
};

//加工種別名(To)表示
export const B000111KakoshubetsuNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.kakoshubetsuCdTo === "") {
    methods.setValue("kakoshubetsuNmTo", data.kakoshubetsuCdTo);
    return;
  }
  await B000111Get({ meishoCd: data.kakoshubetsuCdTo, meishoKbn: "38" })
    .then((response) => {
      methods.setValue("kakoshubetsuNmTo", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("kakoshubetsuNmTo", "");
    });
};

//欠品理由表示
export const B000111KeppinriyuNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.keppinriyuCd === "") {
    methods.setValue("keppinriyuNm", data.keppinriyuCd);
    return;
  }
  await B000111Get({ meishoCd: data.kakoshubetsuCdTo, meishoKbn: "61" })
    .then((response) => {
      methods.setValue("keppinriyuNm", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("keppinriyuNm", "");
    });
};

//明細備考表示
export const B000111Meisaibiko = async (
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = meiMethods.getValues();

  if (typeof data.meisaibikoCdBefore !== "undefined") {
    if (data.meisaibikoCdBefore === data.meisaibikoCd) {
      return;
    } else {
      meiMethods.setValue("meisaibikoCdBefore", data.meisaibikoCd);
    }
  }

  if (data.meisaibikoCd === "") {
    meiMethods.setValue("meisaibiko", data.meisaibikoCd);
    return;
  }
  await B000111Get({ meishoCd: data.meisaibikoCd, meishoKbn: "7" })
    .then((response) => {
      meiMethods.setValue("meisaibiko", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("meisaibiko", "");
    });
};

//明細構成備考表示
export const B000111meisaikoseiBiko = async (
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = meiMethods.getValues();
  if (typeof data.meisaikoseiBikoBefore !== "undefined") {
    if (data.meisaikoseiBikoBefore === data.meisaikoseiBikoCd) {
      return;
    } else {
      meiMethods.setValue("meisaikoseiBikoBefore", data.meisaikoseiBikoCd);
    }
  }

  if (data.meisaikoseiBikoCd === "") {
    meiMethods.setValue("meisaikoseiBiko", data.meisaikoseiBikoCd);
    return;
  }
  await B000111Get({ meishoCd: data.meisaikoseiBikoCd, meishoKbn: "7" })
    .then((response) => {
      meiMethods.setValue("meisaikoseiBiko", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("meisaikoseiBiko", "");
    });
};

//作家名表示
export const B000111SakaNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.sakaCd === "") {
    methods.setValue("sakaNm", data.sakaCd);
    return;
  }
  await B000111Get({ meishoCd: data.sakaCd, meishoKbn: "37" })
    .then((response) => {
      methods.setValue("sakaNm", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("sakaNm", "");
    });
};

//仕入先分類名表示
export const B000111 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.sakaCd === "") {
    methods.setValue("sakaNm", data.sakaCd);
    return;
  }
  await B000111Get({ meishoCd: data.sakaCd, meishoKbn: "37" })
    .then((response) => {
      methods.setValue("sakaNm", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("sakaNm", "");
    });
};

//加工種別名表示
export const B000111KakoshubetsuNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.kakoshubetsuCd === "") {
    methods.setValue("kakoshubetsuNm", data.kakoshubetsuCd);
    return;
  }
  await B000111Get({ meishoCd: data.kakoshubetsuCd, meishoKbn: "38" })
    .then((response) => {
      methods.setValue("kakoshubetsuNm", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("kakoshubetsuNm", "");
    });
};

// WH 単価名表示
export const B000111WhtankaNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.whtankaCd === "") {
    methods.setValue("whtankaNm", data.whtankaCd);
    return;
  }
  await B000111Get({ meishoCd: data.whtankaCd, meishoKbn: "39" })
    .then((response) => {
      methods.setValue("whtankaNm", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("whtankaNm", "");
    });
};

// WH 原単価名表示
export const B000111WhgentankaNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.whgentankaCd === "") {
    methods.setValue("whgentankaNm", data.whgentankaCd);
    return;
  }
  await B000111Get({ meishoCd: data.whgentankaCd, meishoKbn: "40" })
    .then((response) => {
      methods.setValue("whgentankaNm", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("whgentankaNm", "");
    });
};

//伝票種別名表示・区分1取得
export const B000111DenpyoshubetsuNmKbn1 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.denpyoshubetsuCd === "") {
    methods.setValue("denpyoshubetsuNm", data.denpyoshubetsuCd);
    methods.setValue("kbn1", data.denpyoshubetsuCd);
    return;
  }
  await B000111Get({
    meishoCd: data.denpyoshubetsuCd,
    meishoKbn: "33",
  })
    .then((response) => {
      methods.setValue("denpyoshubetsuNm", response.data.meishoNm1 ?? "");
      methods.setValue("kbn1", response.data.kbn1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("denpyoshubetsuNm", "");
      methods.setValue("kbn1", "");
    });
};

// 得意先分類名1取得
export const B000111TokuibunNm1 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tokuibunCd1 === "") {
    methods.setValue("tokuibunNm1", data.tokuibunCd1);
    return;
  }
  await B000111Get({
    meishoCd: data.tokuibunCd1,
    meishoKbn: "11",
  })
    .then((response) => {
      methods.setValue("tokuibunNm1", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuibunNm1", "");
    });
};

// 得意先分類名2取得
export const B000111TokuibunNm2 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tokuibunCd2 === "") {
    methods.setValue("tokuibunNm2", data.tokuibunCd2);
    return;
  }
  await B000111Get({
    meishoCd: data.tokuibunCd2,
    meishoKbn: "12",
  })
    .then((response) => {
      methods.setValue("tokuibunNm2", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuibunNm2", "");
    });
};

// 得意先分類名3取得
export const B000111TokuibunNm3 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tokuibunCd3 === "") {
    methods.setValue("tokuibunNm3", data.tokuibunCd3);
    return;
  }
  await B000111Get({
    meishoCd: data.tokuibunCd3,
    meishoKbn: "13",
  })
    .then((response) => {
      methods.setValue("tokuibunNm3", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuibunNm3", "");
    });
};

// 得意先分類名4取得
export const B000111TokuibunNm4 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tokuibunCd4 === "") {
    methods.setValue("tokuibunNm4", data.tokuibunCd4);
    return;
  }
  await B000111Get({
    meishoCd: data.tokuibunCd4,
    meishoKbn: "14",
  })
    .then((response) => {
      methods.setValue("tokuibunNm4", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuibunNm4", "");
    });
};

// 得意先分類名5取得
export const B000111TokuibunNm5 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tokuibunCd5 === "") {
    methods.setValue("tokuibunNm5", data.tokuibunCd5);
    return;
  }
  await B000111Get({
    meishoCd: data.tokuibunCd5,
    meishoKbn: "15",
  })
    .then((response) => {
      methods.setValue("tokuibunNm5", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuibunNm5", "");
    });
};

// 商品分類名1取得
export const B000111ShobumNm1 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shobunCd1 === "") {
    methods.setValue("shobunNm1", data.shobunCd1);
    return;
  }
  await B000111Get({
    meishoCd: data.shobunCd1,
    meishoKbn: "16",
  })
    .then((response) => {
      methods.setValue("shobunNm1", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shobunNm1", "");
    });
};

// 商品分類名2取得
export const B000111ShobumNm2 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shobunCd2 === "") {
    methods.setValue("shobunNm2", data.shobunCd2);
    return;
  }
  await B000111Get({
    meishoCd: data.shobunCd2,
    meishoKbn: "17",
  })
    .then((response) => {
      methods.setValue("shobunNm2", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shobunNm2", "");
    });
};

// 商品分類名3取得
export const B000111ShobumNm3 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shobunCd3 === "") {
    methods.setValue("shobunNm3", data.shobunCd3);
    return;
  }
  await B000111Get({
    meishoCd: data.shobunCd3,
    meishoKbn: "18",
  })
    .then((response) => {
      methods.setValue("shobunNm3", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shobunNm3", "");
    });
};

// 商品分類名4取得
export const B000111ShobumNm4 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shobunCd4 === "") {
    methods.setValue("shobunNm4", data.shobunCd4);
    return;
  }
  await B000111Get({
    meishoCd: data.shobunCd4,
    meishoKbn: "19",
  })
    .then((response) => {
      methods.setValue("shobunNm4", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shobunNm4", "");
    });
};

// 商品分類名5取得
export const B000111ShobumNm5 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shobunCd5 === "") {
    methods.setValue("shobunNm5", data.shobunCd5);
    return;
  }
  await B000111Get({
    meishoCd: data.shobunCd5,
    meishoKbn: "20",
  })
    .then((response) => {
      methods.setValue("shobunNm5", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shobunNm5", "");
    });
};

// 帳票分類名1取得
export const B000111ChohyoBunruiNm1 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.chohyoBunruiCd1 === "") {
    methods.setValue("chohyoBunruiNm1", data.chohyoBunruiCd1);
    return;
  }
  await B000111Get({
    meishoCd: data.chohyoBunruiCd1,
    meishoKbn: "50",
  })
    .then((response) => {
      methods.setValue("chohyoBunruiNm1", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("chohyoBunruiNm1", "");
    });
};

// 帳票分類名2取得
export const B000111ChohyoBunruiNm2 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.chohyoBunruiCd2 === "") {
    methods.setValue("chohyoBunruiNm2", data.chohyoBunruiCd2);
    return;
  }
  await B000111Get({
    meishoCd: data.chohyoBunruiCd2,
    meishoKbn: "51",
  })
    .then((response) => {
      methods.setValue("chohyoBunruiNm2", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("chohyoBunruiNm2", "");
    });
};

// 帳票分類名3取得
export const B000111ChohyoBunruiNm3 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.chohyoBunruiCd3 === "") {
    methods.setValue("chohyoBunruiNm3", data.chohyoBunruiCd3);
    return;
  }
  await B000111Get({
    meishoCd: data.chohyoBunruiCd3,
    meishoKbn: "52",
  })
    .then((response) => {
      methods.setValue("chohyoBunruiNm3", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("chohyoBunruiNm3", "");
    });
};

// 帳票分類名4取得
export const B000111ChohyoBunruiNm4 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.chohyoBunruiCd4 === "") {
    methods.setValue("chohyoBunruiNm4", data.chohyoBunruiCd4);
    return;
  }
  await B000111Get({
    meishoCd: data.chohyoBunruiCd4,
    meishoKbn: "53",
  })
    .then((response) => {
      methods.setValue("chohyoBunruiNm4", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("chohyoBunruiNm4", "");
    });
};

// 帳票分類名5取得
export const B000111ChohyoBunruiNm5 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.chohyoBunruiCd5 === "") {
    methods.setValue("chohyoBunruiNm5", data.chohyoBunruiCd5);
    return;
  }
  await B000111Get({
    meishoCd: data.chohyoBunruiCd5,
    meishoKbn: "54",
  })
    .then((response) => {
      methods.setValue("chohyoBunruiNm5", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("chohyoBunruiNm5", "");
    });
};

// 帳票分類名6取得
export const B000111ChohyoBunruiNm6 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.chohyoBunruiCd6 === "") {
    methods.setValue("chohyoBunruiNm6", data.chohyoBunruiCd6);
    return;
  }
  await B000111Get({
    meishoCd: data.chohyoBunruiCd6,
    meishoKbn: "55",
  })
    .then((response) => {
      methods.setValue("chohyoBunruiNm6", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("chohyoBunruiNm6", "");
    });
};

// 帳票分類名7取得
export const B000111ChohyoBunruiNm7 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.chohyoBunruiCd7 === "") {
    methods.setValue("chohyoBunruiNm7", data.chohyoBunruiCd7);
    return;
  }
  await B000111Get({
    meishoCd: data.chohyoBunruiCd7,
    meishoKbn: "56",
  })
    .then((response) => {
      methods.setValue("chohyoBunruiNm7", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("chohyoBunruiNm7", "");
    });
};

// 帳票分類名8取得
export const B000111ChohyoBunruiNm8 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.chohyoBunruiCd8 === "") {
    methods.setValue("chohyoBunruiNm8", data.chohyoBunruiCd8);
    return;
  }
  await B000111Get({
    meishoCd: data.chohyoBunruiCd8,
    meishoKbn: "57",
  })
    .then((response) => {
      methods.setValue("chohyoBunruiNm8", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("chohyoBunruiNm8", "");
    });
};

// 帳票分類名9取得
export const B000111ChohyoBunruiNm9 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.chohyoBunruiCd9 === "") {
    methods.setValue("chohyoBunruiNm9", data.chohyoBunruiCd9);
    return;
  }
  await B000111Get({
    meishoCd: data.chohyoBunruiCd9,
    meishoKbn: "58",
  })
    .then((response) => {
      methods.setValue("chohyoBunruiNm9", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("chohyoBunruiNm9", "");
    });
};

// 帳票分類名10取得
export const B000111ChohyoBunruiNm10 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.chohyoBunruiCd10 === "") {
    methods.setValue("chohyoBunruiNm10", data.chohyoBunruiCd10);
    return;
  }
  await B000111Get({
    meishoCd: data.chohyoBunruiCd10,
    meishoKbn: "59",
  })
    .then((response) => {
      methods.setValue("chohyoBunruiNm10", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("chohyoBunruiNm10", "");
    });
};

// 帳票分類名11取得
export const B000111ChohyoBunruiNm11 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.chohyoBunruiCd11 === "") {
    methods.setValue("chohyoBunruiNm11", data.chohyoBunruiCd11);
    return;
  }
  await B000111Get({
    meishoCd: data.chohyoBunruiCd11,
    meishoKbn: "60",
  })
    .then((response) => {
      methods.setValue("chohyoBunruiNm11", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("chohyoBunruiNm11", "");
    });
};

// 帳票分類名2取得
export const B000111ChohyoBunruiNm12 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.chohyoBunruiCd12 === "") {
    methods.setValue("chohyoBunruiNm12", data.chohyoBunruiCd12);
    return;
  }
  await B000111Get({
    meishoCd: data.chohyoBunruiCd12,
    meishoKbn: "61",
  })
    .then((response) => {
      methods.setValue("chohyoBunruiNm12", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("chohyoBunruiNm12", "");
    });
};

// 帳票分類名13取得
export const B000111ChohyoBunruiNm13 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.chohyoBunruiCd13 === "") {
    methods.setValue("chohyoBunruiNm13", data.chohyoBunruiCd13);
    return;
  }
  await B000111Get({
    meishoCd: data.chohyoBunruiCd13,
    meishoKbn: "62",
  })
    .then((response) => {
      methods.setValue("chohyoBunruiNm13", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("chohyoBunruiNm13", "");
    });
};

// 帳票分類名14取得
export const B000111ChohyoBunruiNm14 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.chohyoBunruiCd14 === "") {
    methods.setValue("chohyoBunruiNm14", data.chohyoBunruiCd14);
    return;
  }
  await B000111Get({
    meishoCd: data.chohyoBunruiCd14,
    meishoKbn: "63",
  })
    .then((response) => {
      methods.setValue("chohyoBunruiNm14", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("chohyoBunruiNm14", "");
    });
};

// 帳票分類名15取得
export const B000111ChohyoBunruiNm15 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.chohyoBunruiCd15 === "") {
    methods.setValue("chohyoBunruiNm15", data.chohyoBunruiCd15);
    return;
  }
  await B000111Get({
    meishoCd: data.chohyoBunruiCd15,
    meishoKbn: "64",
  })
    .then((response) => {
      methods.setValue("chohyoBunruiNm15", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("chohyoBunruiNm15", "");
    });
};

// 仕入先分類名1取得
export const B000111ShirebunNm1 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shirebunCd1 === "") {
    methods.setValue("shirebunNm1", data.shirebunCd1);
    return;
  }
  await B000111Get({
    meishoCd: data.shirebunCd1,
    meishoKbn: meishoKbn.shirebun1,
  })
    .then((response) => {
      methods.setValue("shirebunNm1", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shirebunNm1", "");
    });
};

// 仕入先分類名2取得
export const B000111ShirebunNm2 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shirebunCd2 === "") {
    methods.setValue("shirebunNm2", data.shirebunCd2);
    return;
  }
  await B000111Get({
    meishoCd: data.shirebunCd2,
    meishoKbn: meishoKbn.shirebun2,
  })
    .then((response) => {
      methods.setValue("shirebunNm2", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shirebunNm2", "");
    });
};

// 仕入先分類名3取得
export const B000111ShirebunNm3 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shirebunCd3 === "") {
    methods.setValue("shirebunNm3", data.shirebunCd3);
    return;
  }
  await B000111Get({
    meishoCd: data.shirebunCd3,
    meishoKbn: meishoKbn.shirebun3,
  })
    .then((response) => {
      methods.setValue("shirebunNm3", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shirebunNm3", "");
    });
};

// 仕入先分類名4取得
export const B000111ShirebunNm4 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shirebunCd4 === "") {
    methods.setValue("shirebunNm4", data.shirebunCd4);
    return;
  }
  await B000111Get({
    meishoCd: data.shirebunCd4,
    meishoKbn: meishoKbn.shirebun4,
  })
    .then((response) => {
      methods.setValue("shirebunNm4", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shirebunNm4", "");
    });
};

// 仕入先分類名5取得
export const B000111ShirebunNm5 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shirebunCd5 === "") {
    methods.setValue("shirebunNm5", data.shirebunCd5);
    return;
  }
  await B000111Get({
    meishoCd: data.shirebunCd5,
    meishoKbn: meishoKbn.shirebun5,
  })
    .then((response) => {
      methods.setValue("shirebunNm5", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shirebunNm5", "");
    });
};

// WH 原単価名表示(from)
export const B000111WhgentankaNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.whtankaCdFrom === "") {
    methods.setValue("whtankaNmFrom", "");
    return;
  }
  await B000111Get({ meishoCd: data.whtankaCdFrom, meishoKbn: "39" })
    .then((response) => {
      methods.setValue("whtankaNmFrom", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("whtankaNmFrom", "");
    });
};

// WH 原単価名表示(to)
export const B000111WhgentankaNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.whtankaCdTo === "") {
    methods.setValue("whtankaNmTo", "");
    return;
  }
  await B000111Get({ meishoCd: data.whtankaCdTo, meishoKbn: "39" })
    .then((response) => {
      methods.setValue("whtankaNmTo", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("whtankaNmTo", "");
    });
};

// 商品分類名1From取得
export const B000111ShobunNm1From = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shobunCd1From === "") {
    methods.setValue("shobunNm1From", data.shobunCd1From);
    return;
  }
  await B000111Get({
    meishoCd: data.shobunCd1From,
    meishoKbn: "16",
  })
    .then((response) => {
      methods.setValue("shobunNm1From", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shobunNm1From", "");
    });
};

// 商品分類名1To取得
export const B000111ShobunNm1To = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shobunCd1To === "") {
    methods.setValue("shobunNm1To", data.shobunCd1To);
    return;
  }
  await B000111Get({
    meishoCd: data.shobunCd1To,
    meishoKbn: "16",
  })
    .then((response) => {
      methods.setValue("shobunNm1To", response.data.meishoNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shobunNm1To", "");
    });
};
